/**
 * Vue translations prototype functions and properties
 * - moved to this file because of the need to use in both store.js and main.js
 */

import {store} from './store.js';

import roRO from './translate/ro_RO.json';
import huHU from './translate/hu_HU.json';
import esES from './translate/es_ES.json';
import deDE from './translate/de_DE.json';

import roRO_eventTypes from './translateEventTypes/ro_RO.json';
import huHU_eventTypes from './translateEventTypes/hu_HU.json';
import esES_eventTypes from './translateEventTypes/es_ES.json';

const tdTranslations = {
    'en_US': {},
    'ro_RO': roRO,
    'de_DE': deDE,
    'hu_HU': huHU,
    'es_ES': esES,
};

const tdTranslationsEventTypes = {
    'en_US': {},
    'ro_RO': roRO_eventTypes,
    'hu_HU': huHU_eventTypes,
    'es_ES': esES_eventTypes,
};

function translate(string, variableData) {
    let language = store.getters.getUserLanguage;

    if (string === undefined || string === null) {
        return '';
    }

    if (typeof string !== 'string') {
        return string;
    }

    // en_US is default (hardcoded)
    if (language !== 'en_US') {
        let escapedString = string.replace(/'/g, "\\'");

        if (tdTranslations[language] !== undefined && tdTranslations[language].hasOwnProperty(escapedString)) {
            string = tdTranslations[language][escapedString];
        }
    }

    // variable data
    if (variableData !== undefined && Array.isArray(variableData) && variableData.length) {
        variableData.forEach(function(variable, index) {
            string = string.replaceAll('$' + index, variable);
        });
    }

    return string;
}

function translateEventTypes(string, variableData) {
    let language = store.getters.getUserLanguage;

    if (string === undefined || string === null) {
        return '';
    }

    // en_US is default (hardcoded)
    if (language !== 'en_US') {
        let escapedString = string.replace(/'/g, "\\'");

        if (tdTranslationsEventTypes[language] !== undefined && tdTranslationsEventTypes[language].hasOwnProperty(escapedString)) {
            string = tdTranslationsEventTypes[language][escapedString];
        }
    }

    // variable data
    if (variableData !== undefined && Array.isArray(variableData) && variableData.length) {
        variableData.forEach(function(variable, index) {
            string = string.replace('$' + index, variable);
        });
    }

    return string;
}

export { tdTranslations, tdTranslationsEventTypes, translate, translateEventTypes };


// WEBPACK FOOTER //
// ./src/tdVueTranslations.js